import { Refresh } from "@mui/icons-material";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import Button from "../shared/components/button/Button";
import { Typography } from "@mui/material";

export const SomethingWentWrong = () => {
  const { t: translate } = useTranslation(["common"]);

  const handleHardReload = () => {
    window.location.href =
      window.location.href.split("?")[0] +
      "?cacheClear=" +
      new Date().getTime();
  };

  return (
    <CenteredContainer>
      <img
        src={require("../assets/cslogo.svg")}
        alt="Creditsafe Logo"
        style={{ paddingBottom: "5px" }}
        width="198px"
        height="50px"
      />
      <StyledTypography>
        {translate("common:somethingWentWrong")}
      </StyledTypography>
      <div>
        <SentimentVeryDissatisfiedIcon sx={{ fontSize: 50 }} />
      </div>
      <StyledButton variant="grey" onClick={() => handleHardReload()}>
        <InlineContainer>
          <StyledTypography>{translate("common:refresh")}</StyledTypography>{" "}
          <Refresh />
        </InlineContainer>
      </StyledButton>
    </CenteredContainer>
  );
};

const CenteredContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  text-align: center;
`;

const InlineContainer = styled.div`
  display: inline-flex;
  align-items: center;
`;

const StyledButton = styled(Button)`
  margin-left: 0.5rem !important;
  margin: 0;
  padding: 0.5rem;
`;

const StyledTypography = styled(Typography)`
  font-size: 1.5rem !important;
`;

export const ButtonBar = styled.div`
  padding: 10px;
`;

export default SomethingWentWrong;
